import React from "react"
import { Button, Select } from "antd"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"

const CustomCalendarToolbar = ({
  label,
  onNavigate,
  onView,
  view,
  views,
  viewingPlanMode,
  users,
  selectedUser,
  setSelectedUser,
  selectedPlan,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      {/* Left navigation */}
      <div>
        <Button onClick={() => onNavigate("PREV")} icon={<LeftOutlined />} />
        <Button onClick={() => onNavigate("TODAY")} className="mx-2">
          Today
        </Button>
        <Button onClick={() => onNavigate("NEXT")} icon={<RightOutlined />} />
      </div>

      {/* Center label */}
      <h5 className="mb-0">{label}</h5>

      {/* Right: User Select and view switch */}
      <div className="d-flex align-items-center gap-2">
        {viewingPlanMode ? (
          <h5 className="mb-0 me-3 bg-light shadow-md p-2 px-3 fw-bold text-dark">{selectedPlan?.planName} Calender</h5>
        ) : (
          <Select
            placeholder="Select User"
            style={{ width: 180 }}
            value={selectedUser}
            onChange={option => {
              {
                setSelectedUser(option)
              }
            }}
            options={users}
          ></Select>
        )}

        {views.includes("month") && (
          <Button
            type={view === "month" ? "primary" : "default"}
            onClick={() => onView("month")}
          >
            Month
          </Button>
        )}
      </div>
    </div>
  )
}

export default CustomCalendarToolbar
